module.exports = __webpack_public_path__ + "static/media/sabb.51233356.svg";